import ImagesScrollbarGallery from "@components/ImagesScrollbarGallery";
import cx from "classnames";
import styles from "./FeaturedImages.module.scss";
import { usePageContext } from "@providers/PageProvider";
import { meetingPage } from "@utils/helper";
import _ from "lodash";

export default function View() {
  const { pageData } = usePageContext();
  const features: any = meetingPage.formatFeaturedImages(pageData);

  return (
    <div data-scroll-section className={cx(styles.section)}>
      <ImagesScrollbarGallery
        {..._.pick(features, ["isAuto", "interval"])}
        galleryName={"meetingAndEventsOverview"}
        images={_.get(features, "slides", [])}
      />
    </div>
  );
}
